import React from 'react';
import PropTypes from 'prop-types';

import { StyledTypography } from './styles';

function ContentTextEmail(props) {
  const { text, email } = props;

  return (
    <StyledTypography>
      {text}
      {' '}
      <StyledTypography color="primary" tag="span">
        {email}
      </StyledTypography>
    </StyledTypography>
  );
}

ContentTextEmail.propTypes = {
  email: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ContentTextEmail;
